import React from "react";
import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { ContextForm } from "cerulean";
import { useNavigate } from "react-router-dom";

interface OrgRoleActionsProps {
  onSubmit: (callback: () => void) => void;
  dangerouslyDisableShowLoading?: boolean;
  isDisabled?: boolean;
  onCancel?: () => void;
}

const OrgRoleActions: React.FC<OrgRoleActionsProps> = ({
  onSubmit,
  dangerouslyDisableShowLoading = false,
  isDisabled = false,
  onCancel,
}) => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();

  return (
    <ContextForm.ActionBar
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "8px",
        marginTop: "40px",
        flexDirection: "row-reverse",
      }}
    >
      <ContextForm.Action onSubmit={onSubmit}>
        <Button
          label={l10n.getString("button-save")}
          testId="submit-manage-roles"
          disabled={isDisabled}
        />
      </ContextForm.Action>
      <ContextForm.Action
        noValidation
        onSubmit={() => {
          if (onCancel) {
            onCancel();
            return;
          }
          navigate("/roles");
        }}
        dangerouslyDisableShowLoading={dangerouslyDisableShowLoading}
      >
        <Button
          kind="negative"
          data-testid="Cancel"
          label="Cancel"
          disabled={isDisabled}
        />
      </ContextForm.Action>
    </ContextForm.ActionBar>
  );
};

export default OrgRoleActions;
